import { FormattedMessage } from 'react-intl';

import { createColumnDefinitionBuilder } from 'ui-components/components/react-table-wrapper/create-column-definition-builder';
import { NumberInput } from 'ui-components/components/number-input';
import { Text, TextType } from 'ui-components/components/text';

import { messages } from '../messages';
import { useAdvancedShippingNoticeContext } from '../../../../advanced-shipping-notice-context';

const QuantityCell = ({ row, isReadOnly, onChangeBoxesPerConfig }) => {
  const { isHeader, isFirstProduct, boxConfigurationId, boxesPerConfig } = row?.original || {};

  const handleChangeBoxesPerConfig = (newQuantity) => {
    onChangeBoxesPerConfig({ boxConfigurationId, newQuantity });
  };

  if (isHeader || !isFirstProduct) {
    return null;
  }

  if (isReadOnly) {
    return <Text textType={TextType.Paragraph} value={boxesPerConfig} />;
  }

  return <NumberInput min={1} onChange={handleChangeBoxesPerConfig} value={boxesPerConfig} />;
};

const HeaderCell = () => {
  const { isParcelConfiguration } = useAdvancedShippingNoticeContext();
  if (isParcelConfiguration) {
    return <FormattedMessage {...messages.boxesPerConfig} />;
  }
  return <FormattedMessage {...messages.palletsPerConfig} />;
};

export const createBoxesPerConfigColumnDefinition = createColumnDefinitionBuilder({
  accessor: 'boxesPerConfig',
  Header: <HeaderCell />,
  Cell: QuantityCell,
  width: 1,
});
